module.exports = __webpack_public_path__ + "img/trash.d5de69c5.svg";